import React, { useContext, useEffect, useState } from "react";
import { useController } from "react-hook-form";
import { useFilePicker } from "use-file-picker";
import { FormContext } from "../../App";
import { MdClose } from "react-icons/md";
import Label from "../Label/Label";
import Button from "../Button/Button";
import style from "./FileInput.module.css";
import ErrorMessage from "../ErrorMessage/ErrorMessage";

const SUPPORTED_FORMATS = Object.freeze(["pdf", "doc", "docx", "txt", "rtf"]);

interface FileInputProps {
  label: string;
  name: string;
  required?: boolean;
}
const FileInput = React.forwardRef<HTMLInputElement, FileInputProps>(
  ({ label, name, required }, ref) => {
    const { control } = useContext(FormContext);
    const {
      field: { onChange },
    } = useController({
      control,
      name,
      rules: {
        required: required && `Please attach your ${label}`,
      },
    });
    const [openFileSelector, { errors, plainFiles }] = useFilePicker({
      accept: SUPPORTED_FORMATS.map((format) => "." + format).join(", "),
      multiple: false,
      readAs: "ArrayBuffer",
      maxFileSize: 1,
    });

    const [files, setFiles] = useState<File[]>([]);
    useEffect(() => {
      onChange(files[0]);
    }, [files, onChange]);
    useEffect(() => {
      setFiles((files) => {
        return files.concat(plainFiles);
      });
    }, [plainFiles]);

    let error = undefined;
    if (errors.length) {
      error = errors?.[0]?.fileSizeToolarge
        ? "File too large"
        : "We couldn't attach your file";
    }

    return (
      <div className={style.fileInputContainer}>
        <Label text={label} required={required} />
        {!files.length && (
          <Button type="button" variant="secondary" onClick={openFileSelector}>
            Attach
          </Button>
        )}
        {files.map((file, index) => (
          <div className={style.fileLabel}>
            <div className={style.fileLabelText}>{file.name}</div>
            <div
              className={style.closeIcon}
              onClick={() =>
                setFiles((files) => {
                  const filesCopy = [...files];
                  filesCopy.splice(index, 1);
                  return filesCopy;
                })
              }
            >
              <MdClose />
            </div>
          </div>
        ))}
        <div className={style.disclaimer}>Maximum file size: 1 MB</div>
        <ErrorMessage name={name} errorText={error} />
      </div>
    );
  }
);
export default FileInput;
